import React from 'react';
import {
    Create,
    SimpleForm,
    required,
    ReferenceField,
    TextField, AutocompleteInput, ReferenceInput, BooleanInput,
} from 'react-admin';
import { redirectToReglaTab } from '../regla/regla-utils';
const redirectToReglaEditEtiquetaTab = (basePath, id, data) => redirectToReglaTab(data.idRegla, 'etiquetas');

const ReglaEtiquetaCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect={redirectToReglaEditEtiquetaTab}>
            <ReferenceField
                source="idRegla"
                reference="regla"
                link={false}
            >
                <TextField source="descripcion" />
            </ReferenceField>
            <ReferenceInput
                source="idEtiqueta"
                reference="etiquetas"
                label="resources.regla-etiqueta.fields.idEtiqueta"
                perPage={100}
                filterToQuery={(searchText) => ({
                    descripcion: searchText ? searchText : "",
                })}
                validate={[required()]}
            >
                <AutocompleteInput optionText="descripcion" optionValue="id" />
            </ReferenceInput>
            <BooleanInput source="excluye" defaultValue={false} />
        </SimpleForm>
    </Create>
);

export default ReglaEtiquetaCreate;
